import { HappinessIndexDetail } from "components/hr-metrics/happiness-index/HappinessIndexDetail";
import { INITIAL_DATA_QUERY_HAPPINESS_INDEX_DETAIL } from "configs/hr-metrics/configTableHappinessIndexList";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { API_HAPPINESS_INDEX } from "services/apiHappinessIndex";
import { useFetch } from "services/useFetch";
import { getAllQueryParams, setQueryParams } from "utils/utils";

const HappinessIndexDetailContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const periodId = searchParams.get('periodId')
    const [modal, setModal] = useState({
        limit: false
    })
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_QUERY_HAPPINESS_INDEX_DETAIL
    const {data: detailList, fetching: getDetail, isLoading} = useFetch({...API_HAPPINESS_INDEX.DETAIL, initPathVariable: periodId}, INITIAL_DATA_QUERY_HAPPINESS_INDEX_DETAIL)    

    useEffect(() => {
        getDetail({...query})
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({...query, ...queryParams})
        setSearchParams(params, {replace: true})
    }

    const setShowModal = (value) => {
        setModal({...modal, ...value})
    }

    const props = {
        dataList: detailList?.data,
        isLoading,
        query,
        modal,
        onChangeQuery,
        setShowModal,
    }

    return (
        <HappinessIndexDetail {...props}/>
    )
}

export default HappinessIndexDetailContainer
